export const CREATE = 'CREATE';
export const DELETE = 'DELETE';
export const UPDATE = 'UPDATE';
export const FETCH_ALL = 'FETCH_ALL';